



function menuMobile() {


    if( jQuery(".icmb-tpl-n5").length ){

        var clickIcon    = ".icmb-tpl-n5 .bctn-n5";
        var rotateIcon   = "actv-n5";
        var menuShow     = ".menuctn-n5";
        var menuActive   = "active-m7";
        var fixSelector  = 'body-fixer-m7';
        var ulselector   = ".icmb-tpl-n5";

        var clickItemMenu   = ".mainitms-tpl-m7 .miitm-m7";



        var rotateActiver = function(evt){

            if( jQuery(ulselector).attr('aria-expanded') == 'false' ){
                jQuery(clickIcon).addClass(rotateIcon);
                jQuery(menuShow).addClass(menuActive);
                jQuery(".header-tpl-m7").addClass("hmbropen-m7");


                if(!jQuery(".header-tpl-m7").hasClass("scrlup-m7")){
                    jQuery('body').addClass(fixSelector);
                }
            }
            else{
                jQuery(clickIcon).removeClass(rotateIcon);
                jQuery(menuShow).removeClass(menuActive);
                jQuery('body').removeClass(fixSelector);
                jQuery(".header-tpl-m7").removeClass("hmbropen-m7");
                jQuery(".mmin-n5").collapse('hide');
            }
        }


        jQuery(document).on('click', clickIcon , function(event) {

            if (jQuery(window).width() <= 992){
                event.preventDefault();
                rotateActiver(this);
            }
        });



        function resizedwMenu(){
            // Haven't resized in 100ms!

            var deviceWidth = jQuery(window).width();

            if( jQuery(ulselector).attr('aria-expanded') == 'true' ){
                if( deviceWidth >= 992){
                    jQuery('body').removeClass(fixSelector);
                }
                else{
                    jQuery('body').addClass(fixSelector);
                }
            }
        }


        var doit;
        jQuery(window).on('resize', function(){
            clearTimeout(doit);
            doit = setTimeout(resizedwMenu, 100);
        });


        jQuery(document).mouseup(function (e){

            if (jQuery(window).width() < 992 && jQuery(".header-tpl-m7").hasClass("hmbropen-m7")){

                var container = jQuery(".header-tpl-m7"); // Give you class or ID

                if (!container.is(e.target) &&            // If the target of the click is not the desired div or section
                    container.has(e.target).length === 0) // ... nor a descendant-child of the container
                {
                    rotateActiver(e);
                }
            }
        });
    }
};





export {menuMobile}
